import DataSKDP from "@/services/DataSKDP";
import { storeSoap } from "@/store/modules/soap";
import { userModule } from "@/store/modules/user";
// import { appModule } from "./app";
import { Dokter } from "@/types";

import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";

export interface SkdpState {
  skdp: Skdp[];
  detailSkdp: Skdp;
  data: Resp;
  inputSkdp: Skdp;
  loading: boolean;
}

interface Skdp {
  id: number;
  register_id: number;
  nomor: string;
  dpjp_id: number;
  unit_id: string;
  tgl_rujukan: string;
  diagnosis: any;
  alasan: any;
  rtl: any;
  tgl_kunjungan: string;
  user_id: number;
  signed: number;
  dokter: Dokter;
  unit: object;
  signature: Array<object>;
}

interface Resp {
  status: string;
  data: object;
}
interface AlasanRtl {
  category: string;
  id: number;
  text: string;
}

@Module({ store, dynamic: true, namespaced: true, name: "storeSKDP" })
class SkdpStore extends VuexModule implements SkdpState {
  detailSkdp = {} as Skdp;
  datadetailSkdp = {};
  inputSkdp = {} as Skdp;
  data = {} as Resp;
  skdp: Skdp[] = [];
  loading = false;
  loadingDetail = false;
  alasan: AlasanRtl[] = [];
  rtl: AlasanRtl[] = [];

  @Mutation SET_DATA(data: Resp) {
    this.data = data;
  }
  @Mutation SET_SKDP(skdp: Skdp[]) {
    this.skdp = skdp;
  }
  @Mutation SET_DETAIL_SKDP(skdp: Skdp) {
    this.detailSkdp = skdp;
  }
  @Mutation SET_DATA_DETAIL_SKDP(skdp: {}) {
    this.datadetailSkdp = skdp;
  }
  @Mutation SET_INPUT_SKDP(skdp: Skdp) {
    this.inputSkdp = skdp;
  }

  @Mutation
  SET_LOADING(val: boolean) {
    this.loading = val;
  }
  @Mutation
  SET_LOADING_DETAIL(val: boolean) {
    this.loadingDetail = val;
  }

  @Action actSkdp_on_reg(reg) {
    this.SET_LOADING(true);

    const dt = DataSKDP.getDataSKDP(reg);
    // appModule.setLoading(true);
    // console.log('awal')
    dt.then(dt => {
      // appModule.setLoading(false);
      // console.log('akhir')
      const detail = dt.data[0];
      this.SET_DATA(dt);
      this.SET_SKDP(dt.data);
      this.SET_DETAIL_SKDP(detail);
      // if (dt.data.length == 0) {
      //   const val = {
      //     id: null, register_id: null, nomor: "", dpjp_id: null, unit_id: "", tgl_rujukan: "", diagnosis: storeSoap.detailSoap[0].a, alasan: "", rtl: "", tgl_kunjungan: "", user_id: null, signed: null, dokter: { id: userModule.user.id, nama: userModule.user.nama }, unit: { id: "", nama: "" }, signature: []
      //   }
      //   this.SET_INPUT_SKDP(val)
      // } else {
      this.SET_INPUT_SKDP(detail);
      // }
    }).finally(() => {
      this.SET_LOADING(false);
    });
  }

  @Action actSKD_on_id(id) {
    this.SET_LOADING_DETAIL(true);
      this.SET_DATA_DETAIL_SKDP({});
    const dt = DataSKDP.getDataSKDPByID(id);
    dt.then(dt => {
      const detail = dt.data;
      this.SET_DATA_DETAIL_SKDP(detail);
      console.log('detaiskdp', detail)
    }).finally(() => {
      this.SET_LOADING_DETAIL(false);
    });
  }

  @Action actSkdp_on_new() {
    const val = {
      id: null,
      register_id: null,
      nomor: "",
      dpjp_id: null,
      unit_id: "",
      tgl_rujukan: "",
      diagnosis: storeSoap.detailSoap[0].a,
      alasan: "",
      rtl: "",
      tgl_kunjungan: "",
      user_id: null,
      signed: null,
      dokter: { id: userModule.user.id, nama: userModule.user.nama },
      unit: { id: "", nama: "" },
      signature: []
    };
    this.SET_INPUT_SKDP(val);
  }

  @Mutation SET_ALASAN(alasan: AlasanRtl[]) {
    this.alasan = alasan;
  }

  @Mutation SET_RTL(rtl: AlasanRtl[]) {
    this.rtl = rtl;
  }

  @Action act_autocomplete_alasan(term: string) {
    // console.log('term',term)
    const dt = DataSKDP.getDataAlasan(term);
    dt.then(dt => {
      const alasan = dt;
      // const status = dt.status
      this.SET_ALASAN(alasan);
    });
  }
  @Action act_autocomplete_rtl(term: string) {
    // console.log('term',term)
    const dt = DataSKDP.getDataRtl(term);
    dt.then(dt => {
      const rtl = dt;
      // const status = dt.status
      this.SET_RTL(rtl);
    });
  }
}

export const storeSKDP = getModule(SkdpStore);
